import { render, staticRenderFns } from "./odd.vue?vue&type=template&id=61f421d9&scoped=true&"
import script from "./odd.vue?vue&type=script&lang=js&"
export * from "./odd.vue?vue&type=script&lang=js&"
import style0 from "./odd.vue?vue&type=style&index=0&id=61f421d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f421d9",
  null
  
)

export default component.exports